
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M6.2 8.823 4.57 8.99c-.81.106-1.466.295-2.052.857-1.267 1.217-1.361 3.277-.21 4.602a2.995 2.995 0 0 0 4.38.196c.585-.562.824-1.23.998-2.07l1.637-8.147c.174-.838.413-1.507.998-2.07a2.995 2.995 0 0 1 4.38.197c1.151 1.325 1.057 3.385-.21 4.602-.586.562-1.242.751-2.052.857l-1.628.176"}})])
          )
        }
      }
    